import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Account } from '@feathr/blackbox';
import { LinkNameCell } from '@feathr/components';

export interface INameCellProps {
  original: Account;
}

/**
 * Account name for the accounts table, linking to that account's own accounts page.
 *
 * Deliberately an `href` rather than a router `to`: the account id in the path scopes every
 * collection in the store, which the app only establishes at boot. A client-side transition would
 * change the URL while leaving the previous account's data on screen, so this has to reload —
 * the same reason AccountSwitcher passes `linkType='href'`.
 */
function NameCell({ original }: Readonly<INameCellProps>): JSX.Element {
  return <LinkNameCell href={`/${original.id}/accounts`} label={original.name} />;
}

export default observer(NameCell);
